<template>
  <ValidationObserver ref="form">
    <div v-if="showApiKeyAuth">
      <InputText
        v-if="needsVanityUrl"
        v-model="baseUrlModel"
        :data-test-id="$testId('baseUrl')"
        label="Base URL"
        name="Base URL"
        rules="required|isUrl|isSecureUrl"
      />
      <InputPassword
        v-model="tokenKeyModel"
        :data-test-id="$testId('tokenKey')"
        label="Token Key"
        name="Token Key"
        rules="required"
        viewableToggle
      />
    </div>
    <div v-if="showClientAuth">
      <InputPassword
        v-model="clientIdModel"
        :data-test-id="$testId('clientId')"
        label="Client ID"
        name="Client ID"
        rules="required"
        viewableToggle
      />
      <InputPassword
        v-model="clientSecretModel"
        :data-test-id="$testId('clientSecret')"
        label="Client Secret"
        name="Client Secret"
        rules="required"
        viewableToggle
      />
    </div>
  </ValidationObserver>
</template>

<script>
import { InputPassword, InputText, addValidationRule } from '@jumpcloud/ui-components';
import { ValidationObserver, extend } from 'vee-validate3';
import { validationRules } from 'client/applications/utils/ApplicationUtils';

const { isSecureUrl, isUrl } = validationRules;
const validators = [isSecureUrl, isUrl];
validators.forEach(validator => {
  extend(validator.name, validator.config);
  addValidationRule(validator.name, validator.config);
});

export default {
  name: 'IdmPrebuiltCredentialsForm',

  components: {
    InputPassword,
    InputText,
    ValidationObserver,
  },

  props: {
    baseUrl: {
      type: String,
      default: '',
    },

    clientId: {
      type: String,
      default: '',
    },

    clientSecret: {
      type: String,
      default: '',
    },

    needsVanityUrl: {
      type: Boolean,
      default() {
        return false;
      },
    },

    showApiKeyAuth: {
      type: Boolean,
      default() {
        return false;
      },
    },

    showClientAuth: {
      type: Boolean,
      default() {
        return false;
      },
    },

    tokenKey: {
      type: String,
      default: '',
    },
  },

  computed: {
    baseUrlModel: {
      set(value) {
        this.$emit('baseUrlInput', value);
      },
      get() {
        return this.baseUrl;
      },
    },

    clientIdModel: {
      set(value) {
        this.$emit('clientIdInput', value);
      },
      get() {
        return this.clientId;
      },
    },

    clientSecretModel: {
      set(value) {
        this.$emit('clientSecretInput', value);
      },
      get() {
        return this.clientSecret;
      },
    },

    tokenKeyModel: {
      set(value) {
        this.$emit('tokenKeyInput', value);
      },
      get() {
        return this.tokenKey;
      },
    },
  },
};
</script>

<style>

</style>
